var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAvatar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.096,
    height: 15.867,
    viewBox: "0 0 16.096 15.867",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_182",
    "data-name": "Group 182",
    transform: "translate(-408.029 -11.835)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Lag_1",
    "data-name": "Lag 1",
    transform: "translate(408.529 12.335)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_341",
    "data-name": "Path 341",
    d: "M7.548,0C2.773,0,0,2.745,0,7.434s2.773,7.434,7.548,7.434S15.1,12.123,15.1,7.434,12.323,0,7.548,0Z",
    fill: "none",
    stroke: "#161f3a",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Lag_1-2",
    "data-name": "Lag 1",
    transform: "translate(413.972 16)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_341-2",
    "data-name": "Path 341",
    d: "M2.106,0A1.91,1.91,0,0,0,0,2.074,1.91,1.91,0,0,0,2.106,4.147,1.91,1.91,0,0,0,4.211,2.074,1.91,1.91,0,0,0,2.106,0Z",
    fill: "none",
    stroke: "#161f3a",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Lag_1-3",
    "data-name": "Lag 1",
    transform: "translate(411.362 22.15)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_341-3",
    "data-name": "Path 341",
    d: "M4.715,0C1.732,0,0,.931,0,2.522S1.732,5.043,4.715,5.043s4.715-.931,4.715-2.522S7.7,0,4.715,0Z",
    transform: "translate(0)",
    fill: "none",
    stroke: "#161f3a",
    strokeWidth: 1
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatar);
export default __webpack_public_path__ + "static/media/avatar.6341c9ac5c0a49281b4bb23049753eda.svg";
export { ForwardRef as ReactComponent };